module.exports = __webpack_public_path__ + "img/aama-logo.dc99b7a1.jpg";